import { recursiveSnakeCaseCipher } from "@src/global_functions/postgrestApi";
import { useMutation } from "@tanstack/react-query";
import { CamelCasedPropertiesDeep } from "type-fest";
import FetchClients, { ClientOutput } from "../client";
import { throwErrorWithHelpText } from "./errors";

export type PropertyInformationRequestBodySnakeCase =
  ClientOutput["rewards"]["PropertyInfoRequest"];
export type PropertyInformationRequestBody =
  CamelCasedPropertiesDeep<PropertyInformationRequestBodySnakeCase>;
export type PropertyInformationResponse =
  ClientOutput["rewards"]["PropertyInfoResponse"];

const propertyInformation = {
  mutations: { usePostPropertyInformation },
} as const;

export default propertyInformation;

const postPropertyInformation = async (
  newUserKey: string,
  body: PropertyInformationRequestBody
) => {
  const { data, error } = await FetchClients.rewards.POST(
    "/property-information",
    {
      params: {
        query: {
          user_key: newUserKey,
        },
      },
      body: recursiveSnakeCaseCipher(body),
    }
  );
  if (data) return data;
  throwErrorWithHelpText(error);
};

function usePostPropertyInformation() {
  return useMutation({
    mutationFn: ({
      body,
      newUserKey,
    }: {
      body: PropertyInformationRequestBody;
      newUserKey: string;
    }) => {
      return postPropertyInformation(newUserKey, body);
    },
  });
}
